// "Ordenar" la selección del lienzo (ADR-2026-09-17-la-seleccion-se-ordena-en-grilla): las
// celdas seleccionadas se acomodan en una grilla que arranca en la esquina superior
// izquierda de lo que ocupaban, con columnas según cuántas son y filas que miden lo que
// su celda más alta, en el orden en que se leían (arriba → abajo, izquierda → derecha).
// Puro: devuelve las posiciones nuevas, y el lienzo las guarda como si las hubieran
// arrastrado.

import { COLUMNAS_MAX, type Posiciones, type Punto } from './acomodo';

/** Más aire que entre las celdas de una tanda recién generada (12): la grilla ordenada es
 *  para mirar y comparar, no para leer una tanda de un vistazo (pedido de Matías). */
export const SEPARACION_ORDENADA = 32;

export interface CeldaAOrdenar {
  id: string;
  position: Punto;
  ancho: number;
  alto: number;
}

/** Hasta 4 van en una fila; de ahí en más, una grilla lo más cuadrada posible (mínimo 3 columnas). */
export function columnasParaOrdenar(cantidad: number): number {
  if (cantidad <= COLUMNAS_MAX) return Math.max(1, cantidad);
  return Math.max(3, Math.ceil(Math.sqrt(cantidad)));
}

export function ordenarEnGrilla(celdas: readonly CeldaAOrdenar[]): Posiciones {
  if (celdas.length === 0) return {};
  const enOrdenDeLectura = [...celdas].sort((a, b) => a.position.y - b.position.y || a.position.x - b.position.x);
  const origen: Punto = {
    x: Math.min(...celdas.map((c) => c.position.x)),
    y: Math.min(...celdas.map((c) => c.position.y)),
  };
  const columnas = columnasParaOrdenar(celdas.length);
  const out: Posiciones = {};
  let y = origen.y;
  for (let inicio = 0; inicio < enOrdenDeLectura.length; inicio += columnas) {
    const fila = enOrdenDeLectura.slice(inicio, inicio + columnas);
    let x = origen.x;
    for (const c of fila) {
      out[c.id] = { x, y };
      x += c.ancho + SEPARACION_ORDENADA;
    }
    y += Math.max(...fila.map((c) => c.alto)) + SEPARACION_ORDENADA;
  }
  return out;
}
